import { AppData } from '../models/AppModel';

export class API {
  static async head(appno: string): Promise<AppData> {
    return fetch(`${process.env.API}/${appno}/head`).then((res) => res.json());
  }
}
